import React from 'react'
import asideModalStore from 'Stores/asideModalStore'
import st from './CourseLevelModal.module.scss'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'

const CourseLevelModal = () => {
  const { modalValues: modalValue, changeValue, check } = asideModalStore

  const handleInputChange = (e) => {
    const { value } = e.target
    changeValue(value, 'name')
  }

  return (
    <div className={st.fieldSet}>
      <FormField>
        <FormLabel isRequired>Course level:</FormLabel>
        <FormInput isError={check('course level')}>
          <input
            type='text'
            placeholder={'Enter course level'}
            name='course level'
            value={modalValue?.name || ''}
            onChange={handleInputChange}
            maxLength={35}
          />
        </FormInput>
      </FormField>
    </div>
  )
}

export default CourseLevelModal
